import { extend, localize } from "vee-validate";
import { required, numeric, size, confirmed, email, digits, regex } from "vee-validate/dist/rules";
import zh_TW from "vee-validate/dist/locale/zh_TW.json";
import en from "vee-validate/dist/locale/en.json";
import vi from "vee-validate/dist/locale/vi.json";
import th from "vee-validate/dist/locale/th.json";
import id from "vee-validate/dist/locale/id.json";

import moment from 'moment';

// Install rules
extend("required", required);
extend("size", size);
extend("numeric", numeric);
extend("confirmed", confirmed);
extend("email", email);
extend("digits", digits);
extend("regex", regex);

extend('id_date', (value) => {
  let date = moment(value, 'YYYY-MM-DD', true).startOf('day');
  if (date.isValid()) {
    const days = date.diff(moment().startOf('day'), 'days');

    if (days <= 0) {
      return "已過期";
    }

    if (days <= 14) {
      return "即將於14天內過期";
    }

    return true;
  }

  return "請輸入正確的日期";
});

// Install messages
// zh_TW.messages.confirmed = "{_field_} 輸入的不一致";
if (window._i18n.locale == 'en') {
  localize('en', en);
} else if (window._i18n.locale == 'vi') {
  localize('vi', vi);
} else if (window._i18n.locale == 'id') {
  localize('id', id);
} else if (window._i18n.locale == 'th') {
  localize('th', th);
} else {
  localize('zh_TW', zh_TW);
}
